export default __webpack_public_path__ + "static/media/news3img1.4aecc84c.png";